<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-body">
            <slot name="body">
              <div class="trailer trailer-16by9">
                <iframe
                  class="trailer-embed"
                  src="https://www.youtube.com/embed/or3ACYmSBoo?rel=0&controls=0&disablekb=1&fs=0&modestbranding=1&showinfo=0&playsinline=1&loop=0"
                  allow="encrypted-media" allowfullscreen></iframe>
              </div>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <div class="modal-close" @click="$emit('close')">CLOSE</div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  replace: true,
  data () {
    return {}
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Modal.vue